import React, { useState } from 'react';
import './Notifications.css';
import { sendNotification } from '../../services/NotificationService.ts';
import CoreTable from '../../coreComponents/Table/Table.tsx';
import Button from '../../coreComponents/Button/Button.tsx';
import Form from '../../coreComponents/Form/Form.tsx';
import { Snackbar, Alert } from '@mui/material';
import { getAllNotifications } from '../../services/NotificationService.ts';
import { useNavigate } from 'react-router-dom';

const Notifications = () => {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customOnly, setCustomOnly] = useState(false);
  const navigate = useNavigate();

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await getAllNotifications(true); 
      const arr = Array.isArray(res.data) ? res.data : (Array.isArray(res.data?.data) ? res.data.data : []);
      setNotifications(arr);
    } catch (e) {
      setSnackbar({ open: true, message: 'Failed to fetch notifications.', severity: 'error' });
      setNotifications([]);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    fetchNotifications();
  }, []);

  const columns = [
    { id: 'id', label: 'ID' },
    { id: 'entityType', label: 'Entity Type' },
    { id: 'title', label: 'Title' },
    { id: 'body', label: 'Body' },
    { id: 'entityId', label: 'Entity ID' },
    { id: 'createdAt', label: 'Created At' },
  ];

  return (
    <div className="notifications-container" style={{ display: 'flex', flexDirection: 'column' }}>
      <div>
        <CoreTable columns={columns} data={notifications} />
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity as 'success' | 'error' | 'info' | 'warning'}
          sx={{ width: '100%', backgroundColor: snackbar.severity === 'success' ? '#43a047' : undefined, color: snackbar.severity === 'success' ? '#fff' : undefined }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const NotificationCard = ({ entityType, label, setSnackbar, afterSend }) => {
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const initialValues = { title: '', body: '', entityId: '' };

  const fields = [
    { type: 'text', name: 'title', label: 'Title', placeholder: 'Title', required: true },
    { type: 'textarea', name: 'body', label: 'Body', placeholder: 'Body', required: true },
    { type: 'number', name: 'entityId', label: `${entityType} ID (optional)`, placeholder: `${entityType} ID (optional)` },
  ];

  const handleSubmit = async (values) => {
    if (!values.title || !values.body) {
      setSnackbar({ open: true, message: 'Title and Body are required.', severity: 'error' });
      return;
    }
    setLoading(true);
    try {
      await sendNotification({
        entityType,
        title: values.title,
        body: values.body,
        ...(values.entityId && { entityId: Number(values.entityId) })
      });
      setSnackbar({ open: true, message: 'Notification sent!', severity: 'success' });
      setFormKey(prev => prev + 1); // Reset form
      if (afterSend) afterSend();
    } catch (e) {
      setSnackbar({ open: true, message: 'Failed to send notification.', severity: 'error' });
    }
    setLoading(false);
  };

  return (
    <div className="notification-card">
      <h3 className="notification-title">{label}</h3>
      <Form
        key={formKey}
        fields={fields}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        onCancel={() => {}}
        buttons={[{
          id: 'send',
          children: loading ? 'Sending...' : 'Send',
          type: 'submit',
          variant: 'contained',
          fullWidth: true
        }]}
      />
    </div>
  );
};

export default Notifications;
